import {
  GBI_ANIMAL_FETCH,
  GBI_ANIMAL_FETCH_SUCCESS,
  GBI_ANIMAL_FETCH_FAIL } from './constants';
import { createSelector } from 'reselect';
import { calcScores } from '../cows/reducer';
import { monthsFromDate } from '../util/datesAndAges';
import addDocumentsToScores from '../cows/util/addDocumentsToScores';

const initialState = {
  animals: {},
  fetching: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GBI_ANIMAL_FETCH: {
      const fetching = { ...state.fetching };
      fetching[action.id] = true;
      return { ...state, fetching };
    }
    case GBI_ANIMAL_FETCH_SUCCESS: {
      const fetching = { ...state.fetching };
      const animals = JSON.parse(JSON.stringify(state.animals));
      fetching[action.animal.id] = false;
      const animal = JSON.parse(JSON.stringify(action.animal));
      calcScores(animal);
      animal.age = monthsFromDate(animal.dob);
      addDocumentsToScores(animal, action.scoreDefinitions);
      if (animal.orgId === '5d0dee629bf92c2352b9961b' && animal.video) { // duplicated in QRTop.js
        animal.video.timestamps = {
          'views': [],
          'straplines': [
            { 'timestamp': 2, 'duration': 8, 'label': 'grass fed' },
            { 'timestamp': 12, 'duration': 7, 'label': 'home bred' },
            {
              'timestamp': 21,
              'duration': 7,
              'label': 'high health and welfare'
            },
            { 'timestamp': 30, 'duration': 7, 'label': 'sustainable' },
            { 'timestamp': 39, 'duration': 9, 'label': 'nutritionally rich' }
          ]
        };
      }
      animals[action.animal.id] = animal;
      return { ...state, fetching, animals };
    }
    case GBI_ANIMAL_FETCH_FAIL: {
      const fetching = { ...state.fetching };
      fetching[action.id] = false;
      return { ...state, fetching };
    }
  }
  return state;
};

const animals = state => state.animals.animals;
const fetching = state => state.animals.fetching;

export const getAnimalsObj = createSelector(
  animals, animals => animals
);

export const getFetchingAnimalsObj = createSelector(
  fetching, fetching => fetching
);

export default reducer;
